import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_PROFILE_CHECK_USERNAME, MANAGE_PROFILE_UPDATE, MANAGE_PROFILE_UPDATE_EMAIL, MANAGE_PROFILE_VERIFY_EMAIL, MANAGE_PROFILE_VIEW } from "config/apiPaths"
import { profile, setUserData } from 'store/slices/authSlice';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const profileApi = createApi({
    reducerPath: 'profileApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/account",
    }),
    tagTypes: ["Profile"],
    endpoints: (builder) => ({

        // get profile
        getProfile: builder.query({
            query: () => ({
                method: "GET",
                url: MANAGE_PROFILE_VIEW
            }),
            transformResponse: (response) => {
                return response.data;
            },
            async onQueryStarted(_, { queryFulfilled, dispatch }) {
                try {
                    let response = await queryFulfilled;
                    const userData = response?.data;
                    dispatch(setUserData({
                        id: userData?.id,
                        firstname: userData?.firstname,
                        lastname: userData?.lastname,
                        username: userData?.username,
                        phone: userData?.phone,
                        email: userData?.email,
                        profile_picture: userData?.therapist_detail?.profile_picture,
                        role: userData?.client_role,
                        on_board_step: userData?.on_board_step,
                        is_on_board_complete: userData?.is_on_board_complete
                        // role_type: userData?.therapist_detail?.type,
                        // therapist_designation: userData?.therapist_detail?.therapist_designation,
                        // therapist_discipline: userData?.therapist_detail?.therapist_discipline,
                        // signature_img: userData?.therapist_detail?.signature_img,
                        // termsAndConditionsStatus: userData?.termsAndConditionsStatus,
                        // assigned_client_category: userData?.therapist_detail?.assigned_client_category,
                        // email_signature: userData?.therapist_detail?.email_signature,
                    }))
                } catch (err) {
                    throw err;
                }
            },
            providesTags: ["Profile"]
        }),

        // check username
        checkUsername: builder.mutation({
            query: (data) => ({
                method: "PUT",
                url: MANAGE_PROFILE_CHECK_USERNAME,
                data
            })
        }),

        // update profile 
        updateProfile: builder.mutation({
            query: (data) => ({
                method: "PUT",
                url: MANAGE_PROFILE_UPDATE,
                data
            }),
            invalidatesTags: ['Profile'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(profile({
                        firstname: arg?.firstname,
                        lastname: arg?.lastname,
                        profile_picture: arg?.profile_picture
                    }));
                } catch (error) {
                    console.error('Profile update failed:', error);
                }
            },
        }),

        // update email 
        updateEmail: builder.mutation({
            query: (data) => ({
                method: "PUT",
                url: MANAGE_PROFILE_UPDATE_EMAIL,
                data
            })
        }),

        // verify email 
        verifyEmail: builder.mutation({
            query: (data) => ({
                method: "PUT",
                url: MANAGE_PROFILE_VERIFY_EMAIL,
                data
            }),
            invalidatesTags: ["Profile"]
        }),

        updateOnboard: builder.mutation({
            query: ({ data, id }) => ({
                url: `/profile/on_boarding/${id}`,
                method: 'PUT',
                data
            }),
            invalidatesTags: ["Profile"],
            async onQueryStarted(id, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Manually invalidate cache for 'Post' tag
                    dispatch(authApi.util.invalidateTags(['Profile']));
                } catch (error) {
                    // handle error if needed
                    console.log('error', error)
                }
            },
        }),
    }),
})

export const {
    useGetProfileQuery,
    useCheckUsernameMutation,
    useUpdateProfileMutation,
    useUpdateEmailMutation,
    useVerifyEmailMutation,
    useUpdateOnboardMutation
} = profileApi;